import { TutorialStep } from 'src/replicant/tutorial/tutorial.ruleset';
import { showTutorial } from '../tutorial.util';
import { TutorialEvent } from '../TutorialController';
import OrdinaryTutorial from './OrdinaryTutorial';

export class ProfileTutorial extends OrdinaryTutorial {
  public readonly step: TutorialStep = 'profile';

  public async handleEvent(event: TutorialEvent): Promise<boolean> {
    if (event !== 'profilePopupOpened') return false;

    await showTutorial('profile', {
      $stepIndex: 8,
      $stepName: 'profile_popup',
    });

    return true;
  }
}
